import {
  Modal,
  Space,
  Typography,
  Divider,
  Tag,
  Button,
  Popconfirm,
  message,
  Row,
  Col,
  Flex,
} from "antd";
import moment from "moment";
import {
  capitalizeTranslated,
  FormatDateTimeFun,
  formatLabel,
  sourceLookup,
  toCapitalize,
  utcDateTimeToLocalPA,
} from "../../../shared";
import {
  ConsentForm,
  MedicalHistory,
  PostOperationInstructions,
  PreOperationInstructions,
} from "../../Printer";
import { useState } from "react";
import { DropDownButton } from "../../utils";
import {
  AuditOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  MedicineBoxOutlined,
  MoreOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { ActionButton } from "../../actionButton";
import { GetPermissions } from "../../../shared/permissions";
import { ViewFUEAppointment } from "../../ViewDetail";
import { ClientPrescriptionModal } from "../../../pages/ppointments/ClientPrescriptionModal";
import { services as api } from "../../../services";
import { sessionapi } from "../../../services/sessionapi";
import { useNavigate } from "react-router";
import { can } from "../../../Auth";
import { AddEditDraft } from "../../../pages/DraftPage/AddEditDraft";
import { draftapi } from "../../../services/draftapi";

const { Title, Text } = Typography;
const ViewDraftDetailsModal = ({ open, selectedDraft, onClose, call }) => {
  const [visiblePreOpDetails, setVisiblePreOpDetails] = useState(false);
  const [visibleConsentFormModal, setVisibleConsentFormModal] = useState(false);
  const [editData, setEditData] = useState(false);
  const [visible, setVisible] = useState(false);
  const [clientInfo, setClientInfo] = useState(null);
  const [visibleViewModal, setVisibleViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [clientIdForMedicalHistory, setClientIdForMedicalHistory] =
    useState(null);
  const [prescriptionVisible, setPrescriptionVisible] = useState(false);
  const [collectIds, setCollectIds] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();

  const handleStatusChange = async (sessionId, status) => {
    try {
      const result = await draftapi?.updateDraftStatus({
        status: status,
        id: Number(sessionId),
      });
      if (result?.success) {
        message.success(`Draft Status updated successfully!`);
        call();
        onClose();
      } else {
        message.error(result?.message || `Draft to update Draft status`);
      }
    } catch (error) {
      console.error(error);
      message.error(
        "An unexpected error occurred while updating Draft status.",
      );
    } finally {
      setLoading(false);
    }
  };

  const DeleteDraft = async (id) => {
    setDeleting(true);
    const result = await draftapi?.deleteDraft(id);

    if (result?.success) {
      message.success("Draft deleted successfully");
      call();
      onClose();
    } else {
      message.error(result?.message || "Failed to delete");
    }
    setDeleting(false);
  };

  const details = selectedDraft?.alldata || null;

  return (
    <>
      <Modal
        title={
          <Space size={5}>
            <Title level={4} className="my-0">
              Draft Details:
            </Title>
            <Tag
              color={
                selectedDraft?.status === "Pending"
                  ? "#FFA500"
                  : selectedDraft?.status === "Appointment scheduled"
                    ? "#52c41a"
                    : selectedDraft?.status === "Callback required"
                      ? "#722ed1"
                      : selectedDraft?.status === "Called"
                        ? "#FFD700"
                        : selectedDraft?.status === "No response"
                          ? "#1677ff"
                          : selectedDraft?.status === "Not interested"
                            ? "#f5222d"
                            : ""
              }
              className="radius-12"
            >
              {capitalizeTranslated(selectedDraft?.status)}
            </Tag>
          </Space>
        }
        zIndex={1000}
        centered
        width={700}
        open={open}
        onOk={onClose}
        onCancel={onClose}
        footer={[
          <Space className="w-100 my-3" style={{ justifyContent: "center" }}>
            {can("Draft", "edit") && (
              <ActionButton
                title="Edit"
                type="primary"
                icon={<EditOutlined />}
                onClick={() => {
                  setVisible(true);
                  setEditData(selectedDraft?.alldata);
                }}
              />
            )}
            {can("Draft", "delete") && (
              <Popconfirm
                title="Are you sure you want to delete this draft?"
                onConfirm={() => DeleteDraft(selectedDraft?.id)}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ loading: deleting }}
              >
                <ActionButton
                  title="Delete"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => {}}
                />
              </Popconfirm>
            )}

            {can("Add Appointment", "create") && (
              <ActionButton
                title="Add Appointment"
                type="primary"
                icon={<MedicineBoxOutlined />}
                onClick={() => {
                  navigate(
                    `/add-appointment?clientId=${selectedDraft.alldata?.client?.id}&draftId=${selectedDraft?.id}`,
                  );
                }}
              />
            )}
            {can("Draft", "status_change") && (
              <DropDownButton
                icon={<MoreOutlined />}
                menu={{
                  items: (() => {
                    const status = selectedDraft?.status;
                    const items = [];
                    if (status !== "Pending") {
                      items.push({
                        label: "Pending",
                        onClick: () =>
                          handleStatusChange(selectedDraft.id, "Pending"),
                      });
                    }
                    if (status !== "Called") {
                      items.push({
                        label: "Called",
                        onClick: () =>
                          handleStatusChange(selectedDraft.id, "Called"),
                      });
                    }
                    if (status !== "Appointment scheduled") {
                      items.push({
                        label: "Appointment Scheduled",
                        onClick: () =>
                          handleStatusChange(
                            selectedDraft.id,
                            "Appointment scheduled",
                          ),
                      });
                    }
                    if (status !== "Not interested") {
                      items.push({
                        label: "Not Interested",
                        onClick: () =>
                          handleStatusChange(
                            selectedDraft.id,
                            "Not interested",
                          ),
                      });
                    }
                    if (status !== "Callback required") {
                      items.push({
                        label: "Callback Required",
                        onClick: () =>
                          handleStatusChange(
                            selectedDraft.id,
                            "Callback required",
                          ),
                      });
                    }
                    if (status !== "No response") {
                      items.push({
                        label: "No Response",
                        onClick: () =>
                          handleStatusChange(selectedDraft.id, "No response"),
                      });
                    }
                    return items;
                  })(),
                }}
              />
            )}
          </Space>,
        ]}
      >
        <div className="my-3">
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Client Name:</Text>
            <Text>{toCapitalize(selectedDraft?.title)}</Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Father Name:</Text>
            <Text>{toCapitalize(details?.client?.fatherName)}</Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Age:</Text>
            <Text>{details?.client?.age} Years</Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Cnic No:</Text>
            <Text>{details?.client?.cnic_passport}</Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Services:</Text>
            <Flex wrap gap={3}>
              {Array.isArray(details?.services) &&
                details?.services.map((service, i) => (
                  <Tag key={i}>{service?.name}</Tag>
                ))}
            </Flex>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Telephone:</Text>
            <Text>
              {details?.client?.countryCode} {details?.client?.telephone}
            </Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Call Again:</Text>
            <Text>{utcDateTimeToLocalPA(details?.when_to_call_again)}</Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Visit:</Text>
            <Text>
              {" "}
              {details?.first_visit_or_returning_client ? (
                <Tag color="green">First Time</Tag>
              ) : (
                <Tag color="red">Not First Time</Tag>
              )}
            </Text>
          </Space>
          <Divider />
          <Space style={{ justifyContent: "space-between", width: "100%" }}>
            <Text strong>Client Priority:</Text>
            <>
              {details?.client_priority === "Low" ? (
                <Tag color="yellow">Low</Tag>
              ) : details?.client_priority === "Normal" ? (
                <Tag color="blue">Normal</Tag>
              ) : details?.client_priority === "High" ? (
                <Tag color="orange">High</Tag>
              ) : (
                <Tag color="red">Urgent</Tag>
              )}
            </>
          </Space>
          <Divider />
        </div>
      </Modal>

      <AddEditDraft
        visible={visible}
        editItem={editData}
        call={call}
        onClose={() => {
          setVisible(false);
          setEditData(null);
          onClose();
        }}
      />
    </>
  );
};
export { ViewDraftDetailsModal };
